import axios from 'axios'
export default axios.create({
  baseURL: 'https://acgsaas.ual.es/things/acg:lab:suitcase-dd',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})